import { On } from "@/lib/features";
import { ContactForm } from "@/components/site/ContactForm";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { Treatments } from "@/components/site/Treatments";
import { Prices } from "@/components/site/Prices";
import { Gallery } from "@/components/site/Gallery";
import { About } from "@/components/site/About";
import { Promo, Team } from "@/components/site/Team";
import { OurWork } from "@/components/site/OurWork";
import { Booking } from "@/components/site/Booking";
import { Visit } from "@/components/site/Visit";
import { Footer, MobileBar } from "@/components/site/Footer";
import { useContent } from "@/lib/content";
import { openFresha, useFreshaFor } from "@/lib/fresha";

export const PageLoader = () => (
  <div className="page-loader" data-testid="page-loader"><img src="/brand/logo-gold.png" alt="Wax Moi" width="835" height="240" /></div>
);

export default function Home() {
  const { data } = useContent();
  const [open, setOpen] = useState(null);
  const [preset, setPreset] = useState(null);
  const loc = useLocation();
  const nav = useNavigate();

  const freshaFor = useFreshaFor();
  const book = (key) => {
    if (freshaFor) { openFresha(freshaFor(key)); return; }
    setOpen(null);
    if (key) setPreset({ key, at: Date.now() });
    setTimeout(() => document.getElementById("book")?.scrollIntoView({ behavior: "smooth" }), 350);
  };

  useEffect(() => {
    if (!data) return;
    const key = new URLSearchParams(loc.search).get("book");
    if (key !== null) { book(key); nav("/", { replace: true }); return; }
    if (loc.hash) setTimeout(() => document.getElementById(loc.hash.slice(1))?.scrollIntoView(), 300);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [!!data]);

  if (!data) return <PageLoader />;
  return (
    <div className="wm has-bar">
      <Header />
      <main id="home">
        <Hero />
        <Treatments onPickTab={setOpen} />
        <Prices open={open} setOpen={setOpen} onBook={book} />
        <Gallery />
        <Promo />
        <About />
        <Team />
        <On k="work"><OurWork /></On>
        <Booking preset={preset} />
        <Visit />
        <On k="messages"><ContactForm /></On>
      </main>
      <Footer />
      <MobileBar />
    </div>
  );
}
